import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import Main from "./Components/Main";

ReactDOM.render(
	<React.StrictMode>
		<Main />
	</React.StrictMode>,
	document.getElementById("root"),
);
